import { createContext, useState, useEffect, useContext } from "react";
import useGeneralContext from "./GeneralContext";

interface Props {
    children: React.ReactNode | React.ReactNode[]
}

export interface IPreferences {
    technical: boolean;
    fundamental: boolean;
    extra: boolean;
    health: boolean;
}

interface IAnalysisTypePreferencesContext {
    preferences: IPreferences;
    setPreferences: React.Dispatch<React.SetStateAction<IPreferences>>
    isOpen: boolean;
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
    openTour: boolean;
    setOpenTour: React.Dispatch<React.SetStateAction<boolean>>
}

export const AnalysisTypePreferencesContext = createContext<IAnalysisTypePreferencesContext>({} as IAnalysisTypePreferencesContext);

export const AnalysisTypePreferencesProvider = ({ children }: Props) => {

    const [preferences, setPreferences] = useState<IPreferences>({
        technical: true,
        fundamental: true,
        extra: true,
        health: true
    });
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [openTour, setOpenTour] = useState<boolean>(false);

    const { tourStart } = useGeneralContext();

    useEffect(() => {
        const currentPreferences = localStorage.getItem("analysis_type_preferences");
        if (!currentPreferences && !tourStart) {
            setIsOpen(true);
        }
        if (currentPreferences) {
            setPreferences(JSON.parse(currentPreferences));
        }
        if (tourStart) {
            setIsOpen(false);
        }
    }, [tourStart]);

    return (
        <AnalysisTypePreferencesContext.Provider value={{ preferences, setPreferences, isOpen, setIsOpen, openTour, setOpenTour }}>
                {children}
        </AnalysisTypePreferencesContext.Provider>
    )
}

export default function useAnalysisTypePreferences() {
    const context = useContext(AnalysisTypePreferencesContext);

    if (!context) {
        throw new Error("useAnalysisTypePreferences must be used whithin an app");
    }

    return context;
}